/**
 * Rozhrani pro oznaceni datoveho typu, ktery obsahuje metody pro porovnani hodnot
 *
 * @generateInstanceClass
 */
export interface IComparable {
    compare(value: any): boolean;
}

export class IComparable {
    private static _properties: string[] = [];
    private static _methods = ["compare"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
